module.exports = __webpack_public_path__ + "img/home copy.912d0eb5.png";